import type {
  ICardDraftProps,
  ICardProps,
  ICellProps,
  TCardDraftId,
  TCardId,
  TCellId,
} from '../types';

const delimiter = '|';

export const buildCardId = ({ itemID, rowID, columnID }: ICardProps): TCardId =>
  `${itemID || ''}${delimiter}${rowID || ''}${delimiter}${columnID || ''}`;

export const parseCardId = (cardId?: TCardId): ICardProps => {
  if (!cardId) return { itemID: '', rowID: '', columnID: '' };

  const [itemID, rowID, columnID] = cardId.split(delimiter);
  return { itemID: itemID ?? '', rowID: rowID ?? '', columnID: columnID ?? '' };
};

export const buildCellId = ({ rowID, columnID }: ICellProps): TCellId =>
  `${rowID || ''}${delimiter}${columnID || ''}`;

export const parseCellId = (cellId?: TCellId): ICellProps => {
  if (!cellId) return { rowID: '', columnID: '' };

  const [rowID, columnID] = cellId.split(delimiter);
  return { rowID: rowID ?? '', columnID: columnID ?? '' };
};

export const buildDraftId = ({ rowID, columnID, itemID }: ICardDraftProps): TCardDraftId => {
  return itemID ? buildCardId({ itemID, rowID, columnID }) : buildCellId({ rowID, columnID });
};

export const parseDraftId = (draftId?: TCardDraftId): ICardDraftProps => {
  if (!draftId) return { rowID: '', columnID: '' };

  const [itemID, rowID, columnID] = draftId.split(delimiter);
  return { itemID, rowID: rowID ?? '', columnID: columnID ?? '' };
};
